import React from "react";
import { Link } from "react-router-dom";

const FooterComp = () => {
  const email = "contact@bonvoytourism.com";
  const phone = "+971559215470";
  const address = "Al Saqar Business Tower, Office 117, Sheikh Zayed Rd, Trade Center Second, DIFC, Dubai, United Arab Emirates";
  const mapsLink = "https://www.google.com/maps/place/Bonvoy+Tourism+%7C+Desert+Safari+And+Tours+Dubai+%7C+Park+Tickets+%7C+Dubai+City+Tour/@25.214,55.277845,9z/data=!4m6!3m5!1s0x3e5f43becd0c7e27:0xdf96e3a5a5936a71!8m2!3d25.2139997!4d55.2778447!16s%2Fg%2F11wc9221z2?hl=en&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";
  const whatsappLink = `https://wa.me/${phone}`;

  return (
    <footer
      style={{
        boxShadow: "0 0 0 100vmax #090c0d",
        clipPath: "inset(0 -100vmax)",
      }}
      className="bg-[#090c0d] mt-12 md:mt-22 py-[30px] md:py-[60px] flex flex-col-reverse md:flex-row gap-4 justify-between items-center text-[12px] font-light text-[#ebebeb]"
    >
      {/* Email Section */}
      <div className="text-center md:text-left">
        <p className="mb-2">
          Email:{" "}
          <a
            href={`mailto:${email}`}
            className="hover:text-[#ff9219] no-underline"
          >
            {email}
          </a>
        </p>
        <div className="flex justify-center md:justify-start items-center gap-4 mb-2">
          <a href="https://www.facebook.com/bonvoytourism" target="_blank" rel="noreferrer">
            <img src="/images/header/facebook.png" alt="fb" width={20} height={20} />
          </a>
          <a href="https://www.instagram.com/bonvoytourism" target="_blank" rel="noreferrer">
            <img src="/images/header/insta.png" alt="insta" width={20} height={20} />
          </a>
          <a href="https://www.tripadvisor.com/Attraction_Review-g295424-d29787943-Reviews-Bonvoy_Tourism-Dubai_Emirate_of_Dubai.html" target="_blank" rel="noreferrer">
            <img src="/images/header/tripadvisor.png" className="pt-[10px]" alt="x" width={24} height={24} />
          </a>
        </div>
        <p>Copyright © 2025 Bonvoy Tourism. All Rights Reserved.</p>
      </div>

      {/* Logo */}
      <Link to="/">
        <img src="/images/header/logo.png" alt="logo" width={102} height={50} />
      </Link>

      {/* Address & Phone */}
      <div className="text-center md:text-right">
        <p className="mb-2 max-w-[300px]">
          <a
            href={mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#ff9219] no-underline"
          >
            {address}
          </a>
        </p>
        <p>
          Phone:{" "}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#ff9219] no-underline"
          >
            +971-55-9215470
          </a>
        </p>
      </div>
    </footer>
  );
};

export default FooterComp;
